import { FormDialog } from "components/dialog/form"
import { EditMemoForm, useEditMemoForm } from "../form/editMemo"

type EditMemoDialogProps = {
	memo: string
	onSubmit: (data: string) => void
	onClose: () => void
}
export const EditMemoDialog = ({
	memo,
	onSubmit,
	onClose
}: EditMemoDialogProps) => {
  const form = useEditMemoForm({ memo, onSubmit })
	return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title="メモを編集"
      body={<EditMemoForm {...form}/>}
      submitLabel="実行"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}